import type { PanoramaImage } from '@state/panorama'

export function calculateRelativeAngle(current: PanoramaImage, target: PanoramaImage) {
  // Map coordinates: assume y is "forward", x is "right" in store space
  const dx = target.x - current.x
  const dy = target.y - current.y

  // Calculate direction angle from current to target
  const theta = Math.atan2(dx, dy)

  // Apply the camera's yaw correction (how the pano is rotated vs map)
  const yawDeg = current.yaw ?? 0
  const yaw = (yawDeg * Math.PI) / 180
  return theta - yaw
}